import React from 'react'

export default function ErrorFallback(): JSX.Element {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
        textAlign: 'center',
        padding: 16
      }}
    >
      <div style={{ fontSize: 96, lineHeight: 1 }}>😵‍💫</div>
      <div style={{ marginTop: 16, fontSize: 18, color: '#444' }}>
        There's been an error on our end. To resolve, please try refreshing the page or closing and re-opening the application.
      </div>
    </div>
  )
}

